import { CheckIcon, CopyIcon } from "Assets/icons";
import { successMessageToast } from "helpers/common";
import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";

const ClipboardCopyBtn = ({ textToCopy }) => {
  const [copied, setCopied] = useState(false);

  const handleClick = () => {
    if(!textToCopy || !navigator) {
      return;
    }
    navigator.clipboard.writeText(textToCopy);
    setCopied(true);
  }

  useEffect(() => {
    let timer;
    if(copied) {
      timer = setTimeout(() => setCopied(false), 3000);
    }
    return () => clearTimeout(timer);
  }, [copied])

  return (
    <Button
      style={{ minWidth: "unset" }}
      className="d-flex align-items-center justify-content-center p-1 commonBtn h-auto w-auto"
      onClick={handleClick}
    >
      {copied ? (
        <CheckIcon />
      ):(
        <CopyIcon />
      )}
    </Button>
  )
}

export default ClipboardCopyBtn;